
import React from "react";

export default function Logs() {

  return (
    <div>
      OperatorLogs.js
    </div>
  );
}



